import { Box, Typography } from '@mui/material';
import React from 'react';
import { MultiChoiceWithTextAggregation as MultiChoiceWithTextAggregationType } from '../../redux/types';

type Props = {
  data: MultiChoiceWithTextAggregationType;
}

const MultiChoiceWithTextAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
      Object.entries(data.payload).map(([key, val]) => {
        const {
          text, inputs, correct, count,
        } = val;
        return (
          <Box key={key} sx={{ my: '0.8rem' }}>
            <Typography component="span" sx={correct ? { fontWeight: 500 } : {}}>
              {`${text} `}
            </Typography>
            <Typography variant="body2" color="grey.500" component="span">
              {`×${count}`}
            </Typography>
            {
              inputs && Object.keys(inputs).length > 0 && (
                <Box>
                  <Typography variant="body2" color="grey.500" component="span">
                    [
                    {
                      Object.entries(inputs).map(([key2, val2]) => (
                        <Typography key={key2} variant="body2" color="grey.500" component="div">
                          {`${key2}×${val2}`}
                        </Typography>
                      ))
                    }
                    ]
                  </Typography>
                </Box>
              )
            }
          </Box>
        );
      })
    }
  </Box>
);

export default MultiChoiceWithTextAggregation;
